export enum NotificationType {
    SalesQuotation = 0,
    PurchaseOrder = 1,
    SalesOrder = 2,
    LoadingOrder = 3,
    SalesDelivery = 4
}